import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import App from './App.vue';
import { isNil } from 'ramda';
import i18n from '@/plugins/i18n';
import Api from '@/plugins/Api.js';

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);
Vue.use(Api);

const extras = new Vue({
    i18n,
    render: h => h(App, { ref: 'extras' })
}).$mount('#app');

const form = document.querySelector('form.shopping');

if (!isNil(form)) {
    (form as HTMLElement).addEventListener('submit', evt => {
        evt.preventDefault();
        const target = evt.currentTarget as HTMLFormElement;
        const action = target.getAttribute('action');
        const method = target.getAttribute('method');
        let type: string = '';
        const body: any = {};
        let redirect: string = '';

        if (target.nodeName === 'FORM') {
            [...target.elements].forEach(field => {
                if (field.getAttribute('name') === 'redirect') {
                    redirect = field.getAttribute('value') || '';
                } else if (field.getAttribute('name') === 'type') {
                    type = field.getAttribute('value') || '';
                } else if (!isNil(field.getAttribute('name'))) {
                    body[field.getAttribute('name') || ''] = field.getAttribute('value');
                }
            });
        }

        if (extras) {
            (extras.$refs.extras as any).init(type, { method, action }, body);
            (extras.$refs.extras as any)
                .open()
                .then(<Any>(data: Any) => {
                    window.location.href = redirect;
                })
                .catch(<Any>(data: Any) => console.warn(data));
        }
    });
}
